import React, { useMemo } from 'react'
import commons from '../../../commons/commons'
import './bannerHoverx4.css'
import { targetFromUrl } from '../../../utils/url'

const BannerHover = ({ data }) => {
  const { title, imageUrl, description, url, mostrarTitulo, mostrarDescripcion } = data
  let resultBannerHover = []

  resultBannerHover = [
    <div className='hoverx4-container shadow-xl group bg-black' key={title}>
      <div className='hoverx4_ContainerImg'>
        <img className='hoverx4_img opacity-100 group-hover:opacity-70 transition duration-600' src={imageUrl} alt={commons.filterText(title)} />
        <div className='hoverx4_ContainerTitle'>
          {!mostrarTitulo && <div className='hoverx4_title text-white text-3xl p-6'>{title}</div>}
        </div>
      </div>

      <div className='hoverx4_back transition delay-200 duration-600 opacity-0 group-hover:opacity-100'>
        <div className='height_details'>
          {!mostrarDescripcion && <div className='p-6 text-2xl text-white'>{description}</div>}
        </div>
        <button 
          className={`moreInfo ${mostrarTitulo ? 'mt-24' : ''} ${mostrarDescripcion ? 'mt-24' : ''}`} 
          type='button'
        >
          <a href={data.esConsulta ? '/consulta' : url} target={targetFromUrl(url)} rel='noreferrer' className='text-white'>
            + INFO
          </a>
        </button>
      </div>
    </div>,
  ]

  return resultBannerHover
}

export default function BannerHoverx4({ data }) {
  const { banner, categoria } = data
  const bannerListLength = (banner && banner.length) || 0

  const renderHover = useMemo(() => {
    let hoverList = []

    for (let count = 0; count < bannerListLength && count <= 3; count++) {
      hoverList = hoverList.concat([<BannerHover key={banner[count].id} data={banner[count]} />])
    }

    return hoverList
  }, [banner])

  return (
    <div className='container mb-8 md:mb-12'>
      <h3 className='feauteredSevenTwenty-title mb-3 text-gray-600'>{categoria.descripcion}</h3>
      <div className='flex flex-wrap gap-5 justify-center'>{renderHover.sort((a, b) => a.props.data.orden - b.props.data.orden)}</div>
    </div>
  )
}
